import {find, map, isEqual} from 'lodash';
import {from} from 'rxjs';
import {Place} from "app/model/place";
import {Resources} from 'app/app.resource';

export class Points {
    points$() {
        return from(
            Resources.getAgentsPoints()
                .then((points) => points.map((point) => Place.createFromApi(point)))
        );
    }

    markPointsAsInvisible(points) {
        return map(points, (p) => Object.assign(p, {visible: false}));
    }

    markPointAsVisible(points, point) {
        return map(points, (p) => Object.assign(p, {visible: isEqual(p, point)}));
    }

    getPointByLocation(points, location) {
        return find(points, (p) => isEqual(p.getMapPosition().position, location.position));
    }
}